const getSimulationCard = state => {
  const { simulation } = state;
  if (!simulation) {
    return {
      hasSubsidy: false,
      needGops: false,
      hasCodebtor: false
    };
  }
  return {
    hasSubsidy: state.simulation.segment === 'SUBSIDY',
    needGops: state.simulation.offerInputs.operationalExpensesFinancing !== 'DEBTOR',
    hasCodebtor: state.simulation.offerInputs.codebtorIncome > 0
  };
};
const getSummary = state => {
  const income = state.incomeSummary.totalIncome;
  const incomeUf = state.incomeSummary.totalIncomeUf;
  const totalDebt = state.debtSummary.totalMonthlyDebt;
  return {
    totalIncome: {
      label: 'Renta total',
      value: income
    },
    totalIncomeUf: {
      label: 'Renta total UF',
      value: incomeUf
    },
    totalDebt: {
      label: 'Deuda Total',
      value: totalDebt
    }
  };
};

const getEligibility = state => {
  const { eligibility } = state;
  const config = {
    Approved: {
      icon: 'check-circle',
      type: 'is-primary'
    },
    Reviewable: {
      icon: 'circle-minus',
      type: 'is-warning'
    },
    Refused: {
      icon: 'circle-xmark',
      type: 'is-danger'
    }
  };
  if (Object.keys(eligibility).length === 0) {
    return {
      icon: config.Refused,
      list: {}
    };
  }
  const eligibilityList = eligibility.reduce((acc, item) => {
    return { ...acc,
      [item.id]: {
        label: item.label,
        icon: {
          ...config[item.value]
        }
      } };
  }, {});
  const refusedPolicy = eligibility.some(
    item => item.value === 'Refused'
  );
  const approvedPolicy = eligibility.every(
    item => item.value === 'Approved'
  );
  let icon = config.Reviewable;
  icon = refusedPolicy ? config.Refused : icon;
  icon = approvedPolicy ? config.Approved : icon;
  return {
    icon,
    list: eligibilityList
  };
};

export default {
  getSimulationCard,
  getSummary,
  getEligibility
};
